// extracted by mini-css-extract-plugin
export default {"iconBlue":"Happyclient_iconBlue__xYTSj","iconWrapper":"Happyclient_iconWrapper__n4x8B","iconCircle":"Happyclient_iconCircle__VJ3Dz"};